import ServicesObservable from './ServicesObservable';

/**
 * Tarteaucitron Services Manager.
 */
export default class ServicesManager {
  constructor() {
    /**
     * @type {ServicesObservable}
     * @public
     */
    this.observable = new ServicesObservable();

    /**
     * Tarteaucitron plugin.
     *
     * @type {Object}
     * @public
     */
    this.tac = window.tarteaucitron;

    if (this.tac) {
      this.init();
    } else {
      console.error('Tarteaucitron is not enabled.');
    }
  }

  /**
   * Add listener to notify observers of services status.
   */
  init() {
    window.addEventListener('tac.close_alert', () => {
      for (let service in this.tac.state) {
        this.observable.notifyAll(service, this.tac.state[service]);
      }
    });
  }

  /**
   * @param {String} service Service name
   * @param {String} id HTML element ID (used to detect if service is used on the page)
   * @param {Object} config Service configuration if not already exists (Optional)
   * @param {Function} callback Called before add service (Optional)
   *
   * @see https://github.com/AmauriC/tarteaucitron.js#create-custom-service
   */
  addService(service, id, config = null, callback = null) {
    if (
      typeof service === 'string' &&
      service &&
      typeof id === 'string' &&
      id &&
      (!config || typeof config === 'object') &&
      (!callback || typeof callback === 'function')
    ) {
      // add service if not exists
      if (!this.tac.services[service] && config) {
        this.tac.services[service] = config;
      }

      // check if service is used in the page
      if (document.getElementById(id)) {
        // if service not already enabled
        if (this.tac.idprocessed[id] !== true) {
          this.tac.idprocessed[id] = true;

          // actions before add service (e.g.: add content in container)
          if (callback) {
            callback();
          }

          (this.tac.job = this.tac.job || []).push(service);
        }
      } else {
        this.tac.idprocessed[id] = false;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/util/tarteaucitron/ServicesManager.js